<div
  class="ngx-container"
  (dragenter)="dragEnter($event)"
  (dragover)="dragOver($event)"
  (dragleave)="dragLeave($event)"
  (drop)="drop($event)"
>
  <table
    [id]="id"
    #table
    [ngClass]="tableClass === null || tableClass === '' ? 'ngx-table' : tableClass"
    [class.ngx-table__table--tiny]="config.tableLayout.style === 'tiny'"
    [class.ngx-table__table--normal]="config.tableLayout.style === 'normal'"
    [class.ngx-table__table--big]="config.tableLayout.style === 'big'"
    [class.ngx-table__table--borderless]="config.tableLayout.borderless"
    [class.ngx-table__table--hoverable]="config.tableLayout.hover"
    [class.ngx-table__table--striped]="config.tableLayout.striped"
    [class.ngx-table__horizontal-scroll]="config.horizontalScroll && !config.isLoading"
  >
    <thead
      table-thead
      [config]="config"
      [sortKey]="sortKey"
      [sortState]="sortState"
      [selectAllTemplate]="selectAllTemplate"
      [filtersTemplate]="filtersTemplate"
      [additionalActionsTemplate]="additionalActionsTemplate"
      [columns]="columns"
      [isAllSelected]="isAllSelected"
      (selectAll)="onSelectAll()"
      (filter)="onSearch($event)"
      (order)="orderBy($event)"
      (event)="emitEvent($event.event, $event.value, $event.data)"
    ></thead>
    <tbody *ngIf="data">
    <ng-container *ngIf="rowTemplate">
      <ul
        class="ngx-table__table-row-context-menu"
        [ngStyle]="{
            position: 'absolute',
            top: rowContextMenuPosition.top,
            left: rowContextMenuPosition.left
          }"
        *ngIf="rowContextMenuPosition.top"
      >
        <ng-container
          [ngTemplateOutlet]="rowContextMenu"
          [ngTemplateOutletContext]="{ $implicit: rowContextMenuPosition.value }"
        >
        </ng-container>
      </ul>
      <ng-container
        *ngFor="
              let row of data
                | sort: sortBy
                | search: term:filteredCountSubject
                | global: globalSearchTerm:filteredCountSubject
                | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count, id: id }
            "
      >
        <tr
          (click)="onClick($event, row, '', null, data.indexOf(row))"
          #contextMenu
          (contextmenu)="onRowContextMenu($event, row, '', null, data.indexOf(row))"
          (dblclick)="onDoubleClick($event, row, '', null, data.indexOf(row))"
          [class.ngx-table__table-row--selected]="
                data.indexOf(row) === selectedRow && !config.selectCell
              "
        >
          <ng-container
            [ngTemplateOutlet]="rowTemplate"
            [ngTemplateOutletContext]="{ $implicit: row, index: data.indexOf(row) }"
          >
          </ng-container>
          <td *ngIf="config.detailsTemplate">
                <span
                  class="ngx-icon"
                  *ngIf="arrowDefinition"
                  [ngClass]="
                    isRowCollapsed(data.indexOf(row))
                      ? 'ngx-icon-arrow-down'
                      : 'ngx-icon-arrow-right'
                  "
                  (click)="collapseRow(data.indexOf(row))"
                >
                </span>
          </td>
        </tr>
        <tr
          *ngIf="
                (config.detailsTemplate && selectedDetailsTemplateRowId.has(data.indexOf(row))) ||
                config.collapseAllRows
              "
        >
          <td [attr.colspan]="columns.length + 1">
            <ng-container
              [ngTemplateOutlet]="detailsTemplate"
              [ngTemplateOutletContext]="{ $implicit: row, index: data.indexOf(row) }"
            >
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!rowTemplate && !config.groupRows">
      <ul
        class="ngx-table__table-row-context-menu"
        [ngStyle]="{
            position: 'absolute',
            top: rowContextMenuPosition.top,
            left: rowContextMenuPosition.left
          }"
        *ngIf="rowContextMenuPosition.top"
      >
        <ng-container
          [ngTemplateOutlet]="rowContextMenu"
          [ngTemplateOutletContext]="{ $implicit: rowContextMenuPosition.value }"
        >
        </ng-container>
      </ul>
      <ng-container
        *ngFor="
              let row of data
                | sort: sortBy
                | search: term:filteredCountSubject
                | global: globalSearchTerm:filteredCountSubject
                | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count, id: id }
            "
      >
        <tr
          [class.ngx-table__table-row--selected]="data.indexOf(row) === selectedRow && !config.selectCell"
          [class.ngx-table__table-row--deleted]="row.deleted === true"
          [class.ngx-table__table-row--disabled]="row.enabled === false"
          [ngClass]="row?.status ? 'status_' + row.status : ''"
        >
          <td *ngIf="config.checkboxes">
            <nb-checkbox
              type="checkbox"
              id="checkbox-{{ data.indexOf(row) }}"
              [checked]="selectedCheckboxes.has(data.indexOf(row))"
              (checkedChange)="onCheckboxSelect($event, row, data.indexOf(row))"
            />
          </td>
          <td *ngIf="config.radio">
            <label>
              <input
                type="radio"
                id="radio-{{ data.indexOf(row) }}"
                name="radio"
                (change)="onRadioSelect($event, row, data.indexOf(row))"
              />
            </label>
          </td>
          <ng-container *ngFor="let column of columns; let colIndex = index">
            <td
              (click)="onClick($event, row, column.key, colIndex, data.indexOf(row))"
              #contextMenu
              (contextmenu)="onRowContextMenu($event, row, column.key, colIndex, data.indexOf(row))"
              (dblclick)="onDoubleClick($event, row, column.key, colIndex, data.indexOf(row))"
              [class.pinned-left]="column.pinned"
              [ngClass]="column.cssClass ? column.cssClass.name : ''"
              [style.left]="styleService.pinnedWidth(column.pinned, colIndex)"
              [class.ngx-table__table-col--selected]="colIndex === selectedCol && !config.selectCell"
              [class.ngx-table__table-cell--selected]="
                    colIndex === selectedCol &&
                    data.indexOf(row) === selectedRow &&
                    !config.selectCol &&
                    !config.selectRow
                  "
            >
              @if (column.cellTemplate) {
                <ng-container
                  [ngTemplateOutlet]="column.cellTemplate"
                  [ngTemplateOutletContext]="{
                      $implicit: row,
                      rowIndex: data.indexOf(row),
                      column: column
                    }"
                >
                </ng-container>
              } @else if (column.type == 'date') {
                {{ row[column.key] | date: 'dd.MM.yyyy' }}

              } @else if (column.type == 'date-timepicker-input') {
                {{ row[column.key] | date: 'dd.MM.yyyy HH:mm:ss' }}

              } @else if (column.type == 'checkbox' && column.key == 'enabled') {
                <nb-toggle [(checked)]="row.enabled" (checkedChange)="onEnabled($event, row.id)"/>

              } @else if (colTemplate) {
                <ng-container
                  [ngTemplateOutlet]="colTemplate"
                  [ngTemplateOutletContext]="{ $implicit: row, colIndex: colIndex, rowIndex: data.indexOf(row), column: column }"
                >
                </ng-container>

              } @else {
                {{ row | render: column.key }}
              }
            </td>
          </ng-container>
          <td *ngIf="config.additionalActions || config.detailsTemplate">
                <span
                  class="ngx-icon"
                  *ngIf="arrowDefinition"
                  [ngClass]="
                    isRowCollapsed(data.indexOf(row))
                      ? 'ngx-icon-arrow-down'
                      : 'ngx-icon-arrow-right'
                  "
                  (click)="collapseRow(data.indexOf(row))"
                >
                </span>
          </td>
        </tr>
        <tr
          *ngIf="
                (config.detailsTemplate && selectedDetailsTemplateRowId.has(data.indexOf(row))) ||
                config.collapseAllRows
              "
        >
          <td *ngIf="config.checkboxes || config.radio"></td>
          <td [attr.colspan]="columns.length + 1">
            <ng-container
              [ngTemplateOutlet]="detailsTemplate"
              [ngTemplateOutletContext]="{ $implicit: row, index: data.indexOf(row) }"
            >
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!rowTemplate && config.groupRows">
      <ng-container
        *ngFor="
            let group of grouped
              | sort: sortBy:config
              | search: term:filteredCountSubject:config
              | global: globalSearchTerm:filteredCountSubject
              | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count, id: id };
            let rowIndex = index
          "
      >
        <tr>
          <ng-container *ngIf="!groupRowsHeaderTemplate">
            <td [attr.colspan]="columns.length">
              <div>{{ group[0][groupRowsBy] }} ({{ group.length }})</div>
            </td>
          </ng-container>
          <ng-container
            *ngIf="groupRowsHeaderTemplate"
            [ngTemplateOutlet]="groupRowsHeaderTemplate"
            [ngTemplateOutletContext]="{
                total: group.length,
                key: groupRowsBy,
                value: group[0] ? group[0][groupRowsBy] : '',
                group: group,
                index: rowIndex
              }"
          >
          </ng-container>
          <td>
              <span
                class="ngx-icon"
                *ngIf="arrowDefinition"
                [ngClass]="
                  isRowCollapsed(rowIndex) ? 'ngx-icon-arrow-down' : 'ngx-icon-arrow-right'
                "
                (click)="collapseRow(rowIndex)"
              >
              </span>
          </td>
        </tr>
        <ng-container *ngIf="selectedDetailsTemplateRowId.has(rowIndex)">
          <tr *ngFor="let row of group">
            <td *ngFor="let column of columns">
              {{ row | render: column.key }}
              <!-- TODO allow users to add groupRowsTemplateRef -->
            </td>
            <td></td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-container>
    </tbody>
    <!--    <tbody-->
    <!--      *ngIf="data && config.rowReorder"-->
    <!--      class="ngx-draggable-row-area"-->
    <!--      cdkDropList-->
    <!--      (cdkDropListDropped)="onDrop($event)"-->
    <!--    >-->
    <!--    <ng-container *ngIf="!rowTemplate && !config.groupRows">-->
    <!--      <ng-container-->
    <!--        *ngFor="-->
    <!--            let row of data-->
    <!--              | sort: sortBy-->
    <!--              | search: term:filteredCountSubject-->
    <!--              | global: globalSearchTerm:filteredCountSubject-->
    <!--              | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count, id: id }-->
    <!--          "-->
    <!--      >-->
    <!--        <tr-->
    <!--          class="ngx-draggable-row"-->
    <!--          cdkDrag-->
    <!--          (cdkDragStarted)="onDragStart($event)"-->
    <!--          [cdkDragStartDelay]="config.reorderDelay || 0"-->
    <!--          cdkDragLockAxis="y"-->
    <!--        >-->
    <!--          <td *ngIf="config.checkboxes">-->
    <!--            <nb-checkbox-->
    <!--              type="checkbox"-->
    <!--              id="checkbox-{{ data.indexOf(row) }}"-->
    <!--              [checked]="selectedCheckboxes.has(data.indexOf(row))"-->
    <!--              (checkedChange)="onCheckboxSelect($event, row, data.indexOf(row))"-->
    <!--            />-->
    <!--          </td>-->
    <!--          <td *ngIf="config.radio">-->
    <!--            <label>-->
    <!--              <input-->
    <!--                type="radio"-->
    <!--                id="radio-draggable-{{ data.indexOf(row) }}"-->
    <!--                name="radio"-->
    <!--                (change)="onRadioSelect($event, row, data.indexOf(row))"-->
    <!--              />-->
    <!--            </label>-->
    <!--          </td>-->
    <!--          <ng-container *ngFor="let column of columns; let colIndex = index">-->
    <!--            <td-->
    <!--              (click)="onClick($event, row, column.key, colIndex, data.indexOf(row))"-->
    <!--              (dblclick)="onDoubleClick($event, row, column.key, colIndex, data.indexOf(row))"-->
    <!--              [class.ngx-table__table-col&#45;&#45;selected]="-->
    <!--                  colIndex === selectedCol && !config.selectCell-->
    <!--                "-->
    <!--              [class.ngx-table__table-cell&#45;&#45;selected]="-->
    <!--                  colIndex === selectedCol &&-->
    <!--                  data.indexOf(row) === selectedRow &&-->
    <!--                  !config.selectCol &&-->
    <!--                  !config.selectRow-->
    <!--                "-->
    <!--            >-->
    <!--              <div *ngIf="!column.cellTemplate">{{ row | render: column.key }}</div>-->
    <!--              <ng-container-->
    <!--                *ngIf="column.cellTemplate"-->
    <!--                [ngTemplateOutlet]="column.cellTemplate"-->
    <!--                [ngTemplateOutletContext]="{-->
    <!--                    $implicit: row,-->
    <!--                    rowIndex: data.indexOf(row),-->
    <!--                    column: column-->
    <!--                  }"-->
    <!--              >-->
    <!--              </ng-container>-->
    <!--            </td>-->
    <!--          </ng-container>-->
    <!--        </tr>-->
    <!--      </ng-container>-->
    <!--    </ng-container>-->
    <!--    </tbody>-->
    <tbody *ngIf="filterCount === 0">
    <tr class="empty">
      <ng-container *ngIf="noResultsTemplate" [ngTemplateOutlet]="noResultsTemplate"/>
      <td [attr.colspan]="columns && columns.length + 1" *ngIf="!noResultsTemplate">
        <div class="empty">Ничего не найдено</div>
      </td>
    </tr>
    </tbody>
    <tfoot *ngIf="summaryTemplate">
    <tr>
      <ng-container
        [ngTemplateOutlet]="summaryTemplate"
        [ngTemplateOutletContext]="{ total: data.length, limit: limit, page: page }"
      >
      </ng-container>
    </tr>
    </tfoot>
  </table>
  <pagination
    [attr.id]="'pagination' + id"
    [id]="id"
    #paginationComponent
    [config]="config"
    [pagination]="pagination"
    (update)="onPagination($event)"
  />

</div>
